import React from 'react';
import { Chip, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withFormsy } from 'formsy-react';

function AutocompleteFormsy(props) {
    const { options, label, name, required, disabled, className, placeholder, variant = 'outlined', multiple = true } = props;
    const errorMessage = props.isPristine && !props.isFormSubmitted ? null : props.errorMessage;
    const findOption = (value) => options.find((option) => option.value === value) ?? null;
    const selected = multiple ? (props.value || []).map(findOption).filter(Boolean) : findOption(props.value);

    const changeValue = (event, selection) => {
        props.setValue(multiple ? selection.map((option) => option.value) : selection?.value ?? null);
        if (props.onChange) {
            props.onChange(event, selection);
        }
    };

    return (
        <Autocomplete
            multiple={multiple}
            disableCloseOnSelect={multiple}
            className={className}
            options={options}
            value={selected}
            onChange={changeValue}
            disabled={disabled}
            getOptionLabel={(option) => option?.label ?? ''}
            getOptionSelected={(option, value) => option.value === value?.value}
            renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => <Chip key={option.value} label={option.label} size="small" {...getTagProps({ index })} />)}
            renderInput={(params) => <TextField {...params} name={name} label={label} placeholder={placeholder} variant={variant} InputLabelProps={{ ...params.InputLabelProps, required }} error={Boolean(errorMessage)} helperText={errorMessage} />}
        />
    );
}

export default React.memo(withFormsy(AutocompleteFormsy));
